import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Field of the block project-measurement-point-operator ("Messstellenbetreiber") with its payload
 * type (`preparePayloadForGraphQL`). Must match `ProjectMeasurementPointOperatorInput`;
 * `createPayload` reuses the type.
 */
export const PROJECT_MEASUREMENT_POINT_OPERATOR_FIELD_TYPES = {
  measurementPointOperator: 'id',
};

export const PROJECT_MEASUREMENT_POINT_OPERATOR_INPUT_FIELDS = Object.keys(
  PROJECT_MEASUREMENT_POINT_OPERATOR_FIELD_TYPES
);

/** `ProjectMeasurementPointOperatorInput` from the block object: the id of the operator or null. */
export const toProjectMeasurementPointOperatorInput = (project) =>
  preparePayloadForGraphQL(
    { measurementPointOperator: project.measurementPointOperator ?? null },
    PROJECT_MEASUREMENT_POINT_OPERATOR_FIELD_TYPES
  );
